// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio-btn-grp{gap:12px;align-items:flex-start}.radio-btn-grp b{font-family:Inter;font-weight:700}.radio-btn-grp button{position:relative;gap:12px}.radio-btn-grp button:before{content:\"\";height:22px;width:22px;border-radius:50%;border:1px solid #e6e6e6;border-color:#ccc;background:#fff;flex-shrink:0}.radio-btn-grp button.opt-selected:before{height:8px;width:8px;border-color:var(--theme-color);border-width:8px}", ""]);
// Exports
module.exports = exports;
